.modal {
	display: flex;
	flex-direction: column;
	gap: var(--size-6);
}

.error {
	color: var(--color-error-text);
	font-size: var(--text-caption);

	&:empty {
		display: none;
	}
}

.actions {
	display: flex;
	align-items: center;
	gap: var(--size-3);
	justify-content: flex-end;
}
